import React from "react";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="text-xs uppercase tracking-widest text-white/60">
      <ol className="flex flex-wrap items-center gap-1.5">
        <li><Link to="/" className="hover:text-solar">Home</Link></li>
        {items.map((it, i) => (
          <React.Fragment key={`${it.to || ""}-${it.label}-${i}`}>
            <CaretRight size={10} weight="bold" className="text-white/40" />
            <li>
              {it.to ? (
                <Link to={it.to} className="hover:text-solar">{it.label}</Link>
              ) : (
                <span className="text-solar">{it.label}</span>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
}
